import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

class RoleField extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.roles = {};
    _.each(props.options, (o) => {
      this.roles[o.value] = o.label;
    });
  }

  removeRole(roleId) {
    this.props.handleChange(null, roleId, true);
  }

  render() {
    const {
      name,
      label,
      required,
      placeholder,
      values = {},
      disabled = false,
      multiple = false,
      errors = {},
      touched = {},
      handleBlur,
      handleChange,
      classes = '',
      validation = {},
      formatting = {},
      options,
      hidden = false,
    } = this.props;
    const uniqueId = _.uniqueId();
    return (
      <div className={hidden ? 'hidden' : ''}>
        <div className={`field ${errors[name] && touched[name] ? 'error' : ''}`}>
          <label
            htmlFor={`${name}__${uniqueId}`}
            className='control-label'
            title={errors[name]}
          >
            {label}
            {required && <span className='text-danger'>*</span>}
          </label>
          <div className='value'>
            {_.map(values[name] || [], r => (
              <div
                key={r}
                className='role'
              >
                {_.get(this.roles, r, r)}
                <i
                  role='button'
                  title='Remove'
                  tabIndex={-1}
                  className='fas fa-times'
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    this.removeRole(r);
                  }}
                />
              </div>
            ))}
          </div>
          <select
            id={`${name}__${uniqueId}`}
            name={name}
            className={classes || 'control-item'}
            value={values[`${name}_available_roles`]}
            onChange={handleChange}
            onBlur={handleBlur}
            ref={(c) => { this.field = c; }}
            validation={{ required, ...validation }}
            formatting={{ ...formatting }}
            disabled={disabled}
            multiple={multiple}
            placeholder={placeholder}
          >
            {_.map(options, (o, i) => (<option key={i} value={o.value}>{o.label}</option>))}
          </select>
          {errors[name] && touched[name] ? <span className='error-message'>Required</span> : null}
        </div>
      </div>
    );
  }
}

RoleField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  values: PropTypes.shape({}),
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}),
  touched: PropTypes.shape({}),
  options: PropTypes.instanceOf(Array),
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
  validation: PropTypes.shape({}),
  formatting: PropTypes.shape({}),
  hidden: PropTypes.bool,
};

RoleField.defaultProps = {
  label: '',
  required: false,
  placeholder: '',
  values: {},
  disabled: false,
  multiple: false,
  errors: {},
  touched: {},
  options: [
    { value: -1, label: 'Add Role' },
    { value: 0, label: 'Super' },
    { value: 10, label: 'Administrator' },
    { value: 20, label: 'Manager' },
    { value: 30, label: 'Analyst' },
    { value: 40, label: 'Responder' },
  ],
  classes: '',
  validation: {},
  formatting: {},
  hidden: false,
};

export default RoleField;



// WEBPACK FOOTER //
// ./src/views/Components/Form/RoleField.js